import './issuer-compliances.scss'

import { Card, Table } from 'antd'
import classnames from 'classnames'
import React, { useState } from 'react'
import { Column, Row } from 'react-display-flex'
import useSWR from 'swr'

import { fetchDetailByDomain } from '../../../../api'
import { emptyCharacter } from '../../../../components/EmptyChar'
import { renderPrincipal } from '../../../../components/tables/table-column-renderers'
import { IsCompliant } from '../IsCompliant'
import {
  buildIssuerCompliancesTableColumns,
  buildShortAndLongCompliancesColumns,
} from './issuer-compliances-table-columns'
import { IssuerCompliance, IssuerCompliancesProps, transformIssuerCompliancesToTableItems } from './models'

export const IssuerCompliances = ({ tenant }) => {
  const [activeIssuanceComplianceCodes, setActiveIssuanceComplianceCodes] = useState(null)

  const { data: issuerCompliances } = useSWR<IssuerCompliancesProps>(
    tenant ? ['/compliances/issuers', tenant] : null,
    fetchDetailByDomain,
  )

  const columns = buildIssuerCompliancesTableColumns()

  return (
    <Card title="Issuer Compliances" className="issuer-compliances" loading={!issuerCompliances}>
      <Row justifyContentSpaceBetween>
        <Column>
          <dt>Trades Count</dt>
          <dd>{issuerCompliances?.tradesCount ? issuerCompliances?.tradesCount : 0}</dd>
        </Column>
        <Column>
          <dt>Amount Invested</dt>
          <dd>{renderPrincipal(issuerCompliances?.amountInvested ? issuerCompliances?.amountInvested : 0)}</dd>
        </Column>
        <Column>
          <dt>Is Compliant</dt>
          <dd>
            <IsCompliant isCompliant={issuerCompliances?.isCompliant} />
          </dd>
        </Column>
        <Column>
          <dt>Long Term Compliance Only</dt>
          <dd>
            <IsCompliant isCompliant={issuerCompliances?.longTermComplianceOnly} />
          </dd>
        </Column>
        <Column>
          <dt>Capital Basis</dt>
          <dd>{issuerCompliances?.capitalBasis ? issuerCompliances?.capitalBasis : emptyCharacter}</dd>
        </Column>
      </Row>

      <Table
        rowClassName={(issuerCompliance: IssuerCompliance) =>
          classnames({ active: activeIssuanceComplianceCodes?.includes(issuerCompliance.code) })
        }
        dataSource={issuerCompliances?.list ? transformIssuerCompliancesToTableItems(issuerCompliances) : []}
        loading={!issuerCompliances}
        columns={columns}
        pagination={false}
        expandable={{
          expandedRowRender: (issuanceCompliance) => buildShortAndLongCompliancesColumns(issuanceCompliance),
          onExpandedRowsChange: (issuerComplianceCodes) => setActiveIssuanceComplianceCodes(issuerComplianceCodes),
        }}
        rowKey="code"
        size="small"
      />
    </Card>
  )
}
